import { Box, BoxProps, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'next-i18next'
import { CustomizableEngraveCartItem } from 'modules/checkout/components/PaidOptions'
import CartOptionHeader from './CartOptionHeader'

interface Props extends BoxProps {
  cartItem: CustomizableEngraveCartItem;
  isDrawerMode?: boolean;
}

export const CartProductConfigurator = ({
  cartItem,
  isDrawerMode,
  ...props
}: Props) => {
  const { t } = useTranslation()

  const elements =
    cartItem?.bundle_options
      .filter(option => option?.label.includes('Element'))
      .sort(
        (a, b) =>
          a?.values[0]?.label.localeCompare(b?.values[0]?.label || '') || 0
      ) || []

  return (
    <Box py={3} {...props}>
      <Flex mb={4}>
        <Text>{t('COMPOSITION_COMPONENTS')}</Text>
      </Flex>

      <Flex
        w={props.w || props.width}
        maxW="100%"
        flexWrap="wrap"
        justifyContent="space-between"
        mb={2}
        sx={{
          '&>div:not(:last-child)': {
            paddingBottom: 4,
            marginBottom: 4,
            borderBottom: 'solid 1px',
            borderColor: 'borderLight',
          },
        }}
      >
        {elements.map(element => (
          <CartOptionHeader
            isDrawerMode={isDrawerMode}
            key={element?.uid}
            value={element?.values[0]?.label}
            price={element?.values[0]?.price}
            fontWeight="light"
          />
        ))}
      </Flex>
    </Box>
  )
}
